var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useState } from "react";
import { Col, Row } from "react-bootstrap";
import { GenericDropdown, } from "../../../../../../shared-library/components/GenericDropdown";
import { NonStreamReportValue } from "../../../../../../shared-library/components/commonTableVal";
import ReportValue from "@frameworks/shared-library/components/commonTableVal";
export var FLMdrp = [
    { title: "FLM", value: "flm" },
    { title: "FTY", value: "fty" },
    { title: "Brokerage Till Date", value: "date" },
];
var BrokerageVolume = function (props) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z;
    var _0 = __read(useState(), 2), brokVolData = _0[0], setBrokVolData = _0[1];
    var _1 = __read(useState(), 2), dropDownData = _1[0], setDropDownData = _1[1];
    var _2 = __read(useState(FLMdrp[0]), 2), FLMdrpValue = _2[0], setFLMdrp = _2[1];
    React.useEffect(function () {
        var _a;
        setBrokVolData(props.data);
        setDropDownData((_a = props.data) === null || _a === void 0 ? void 0 : _a.flmDetails);
    }, [props.data]);
    var BrokerageVolumeColumn = [
        {
            columnName: "Segments",
            key: "Segments",
        },
        {
            columnName: "FTDVolume",
            key: "FTDVolume",
            tdCustomFunction: function (key) {
                return NonStreamReportValue(key);
            },
        },
        {
            columnName: "FTDBrokerage",
            key: "FTDBrokerage",
            tdCustomFunction: function (key) {
                return NonStreamReportValue(key);
            },
        },
        {
            columnName: "FTMVolume",
            key: "FTMVolume",
            tdCustomFunction: function (key) {
                return NonStreamReportValue(key);
            },
        },
        {
            columnName: "FTMBrokerage",
            key: "FTMBrokerage",
            tdCustomFunction: function (key) {
                return NonStreamReportValue(key);
            },
        },
        {
            columnName: "FLMVolume",
            key: "FLMVolume",
            tdCustomFunction: function (key) {
                return NonStreamReportValue(key);
            },
        },
        {
            columnName: "FLMBrokerage",
            key: "FLMBrokerage",
            tdCustomFunction: function (key) {
                return NonStreamReportValue(key);
            },
        },
    ];
    var BrokerageVolumeRows = [
        {
            Segments: "Cash",
            FTDBrokerage: (_a = brokVolData === null || brokVolData === void 0 ? void 0 : brokVolData.revenueBrokingVol) === null || _a === void 0 ? void 0 : _a.casH_BROK_FTD,
            FTDVolume: (_b = brokVolData === null || brokVolData === void 0 ? void 0 : brokVolData.revenueBrokingVol) === null || _b === void 0 ? void 0 : _b.casH_VOL_FTD,
            FTMBrokerage: (_c = brokVolData === null || brokVolData === void 0 ? void 0 : brokVolData.revenueBrokingVol) === null || _c === void 0 ? void 0 : _c.casH_BROK_FTM,
            FTMVolume: (_d = brokVolData === null || brokVolData === void 0 ? void 0 : brokVolData.revenueBrokingVol) === null || _d === void 0 ? void 0 : _d.casH_VOL_FTM,
            FLMBrokerage: dropDownData === null || dropDownData === void 0 ? void 0 : dropDownData.casH_BROK,
            FLMVolume: dropDownData === null || dropDownData === void 0 ? void 0 : dropDownData.casH_VOL,
        },
        {
            Segments: "Futures",
            FTDBrokerage: (_e = brokVolData === null || brokVolData === void 0 ? void 0 : brokVolData.revenueBrokingVol) === null || _e === void 0 ? void 0 : _e.fuT_BROK_FTD,
            FTDVolume: (_f = brokVolData === null || brokVolData === void 0 ? void 0 : brokVolData.revenueBrokingVol) === null || _f === void 0 ? void 0 : _f.fuT_VOL_FTD,
            FTMBrokerage: (_g = brokVolData === null || brokVolData === void 0 ? void 0 : brokVolData.revenueBrokingVol) === null || _g === void 0 ? void 0 : _g.fuT_BROK_FTM,
            FTMVolume: (_h = brokVolData === null || brokVolData === void 0 ? void 0 : brokVolData.revenueBrokingVol) === null || _h === void 0 ? void 0 : _h.fuT_VOL_FTM,
            FLMBrokerage: dropDownData === null || dropDownData === void 0 ? void 0 : dropDownData.fuT_BROK,
            FLMVolume: dropDownData === null || dropDownData === void 0 ? void 0 : dropDownData.fuT_VOL,
        },
        {
            Segments: "Option",
            FTDBrokerage: (_j = brokVolData === null || brokVolData === void 0 ? void 0 : brokVolData.revenueBrokingVol) === null || _j === void 0 ? void 0 : _j.opT_BROK_FTD,
            FTDVolume: (_k = brokVolData === null || brokVolData === void 0 ? void 0 : brokVolData.revenueBrokingVol) === null || _k === void 0 ? void 0 : _k.opT_VOL_FTD,
            FTMBrokerage: (_l = brokVolData === null || brokVolData === void 0 ? void 0 : brokVolData.revenueBrokingVol) === null || _l === void 0 ? void 0 : _l.opT_BROK_FTM,
            FTMVolume: (_m = brokVolData === null || brokVolData === void 0 ? void 0 : brokVolData.revenueBrokingVol) === null || _m === void 0 ? void 0 : _m.opT_VOL_FTM,
            FLMBrokerage: dropDownData === null || dropDownData === void 0 ? void 0 : dropDownData.opT_BROK,
            FLMVolume: dropDownData === null || dropDownData === void 0 ? void 0 : dropDownData.opT_VOL,
        },
        {
            Segments: "Currency",
            FTDBrokerage: (_o = brokVolData === null || brokVolData === void 0 ? void 0 : brokVolData.revenueBrokingVol) === null || _o === void 0 ? void 0 : _o.curR_BROK_FTD,
            FTDVolume: (_p = brokVolData === null || brokVolData === void 0 ? void 0 : brokVolData.revenueBrokingVol) === null || _p === void 0 ? void 0 : _p.curR_VOL_FTD,
            FTMBrokerage: (_q = brokVolData === null || brokVolData === void 0 ? void 0 : brokVolData.revenueBrokingVol) === null || _q === void 0 ? void 0 : _q.curR_BROK_FTM,
            FTMVolume: (_r = brokVolData === null || brokVolData === void 0 ? void 0 : brokVolData.revenueBrokingVol) === null || _r === void 0 ? void 0 : _r.curR_VOL_FTM,
            FLMBrokerage: dropDownData === null || dropDownData === void 0 ? void 0 : dropDownData.curR_BROK,
            FLMVolume: dropDownData === null || dropDownData === void 0 ? void 0 : dropDownData.curR_VOL,
        },
        {
            Segments: "Commodity",
            FTDBrokerage: (_s = brokVolData === null || brokVolData === void 0 ? void 0 : brokVolData.revenueBrokingVol) === null || _s === void 0 ? void 0 : _s.comM_BROK_FTD,
            FTDVolume: (_t = brokVolData === null || brokVolData === void 0 ? void 0 : brokVolData.revenueBrokingVol) === null || _t === void 0 ? void 0 : _t.comM_VOL_FTD,
            FTMBrokerage: (_u = brokVolData === null || brokVolData === void 0 ? void 0 : brokVolData.revenueBrokingVol) === null || _u === void 0 ? void 0 : _u.comM_BROK_FTM,
            FTMVolume: (_v = brokVolData === null || brokVolData === void 0 ? void 0 : brokVolData.revenueBrokingVol) === null || _v === void 0 ? void 0 : _v.comM_VOL_FTM,
            FLMBrokerage: dropDownData === null || dropDownData === void 0 ? void 0 : dropDownData.comM_BROK,
            FLMVolume: dropDownData === null || dropDownData === void 0 ? void 0 : dropDownData.comM_VOL,
        },
        {
            Segments: "Total",
            FTDBrokerage: (_w = brokVolData === null || brokVolData === void 0 ? void 0 : brokVolData.revenueBrokingVol) === null || _w === void 0 ? void 0 : _w.toT_BRK_FTD,
            FTDVolume: (_x = brokVolData === null || brokVolData === void 0 ? void 0 : brokVolData.revenueBrokingVol) === null || _x === void 0 ? void 0 : _x.toT_VOL_FTD,
            FTMBrokerage: (_y = brokVolData === null || brokVolData === void 0 ? void 0 : brokVolData.revenueBrokingVol) === null || _y === void 0 ? void 0 : _y.toT_BRK_FTM,
            FTMVolume: (_z = brokVolData === null || brokVolData === void 0 ? void 0 : brokVolData.revenueBrokingVol) === null || _z === void 0 ? void 0 : _z.toT_VOL_FTM,
            FLMBrokerage: dropDownData === null || dropDownData === void 0 ? void 0 : dropDownData.toT_BRK,
            FLMVolume: dropDownData === null || dropDownData === void 0 ? void 0 : dropDownData.toT_VOL,
        },
    ];
    React.useEffect(function () {
        switch (FLMdrpValue.value) {
            case "flm":
                return setDropDownData(brokVolData === null || brokVolData === void 0 ? void 0 : brokVolData.flmDetails);
            case "date":
                return setDropDownData(brokVolData === null || brokVolData === void 0 ? void 0 : brokVolData.brokTillDate);
            case "fty":
                return setDropDownData(brokVolData === null || brokVolData === void 0 ? void 0 : brokVolData.ftyDetails);
        }
    }, [FLMdrpValue]);
    return (React.createElement("section", { id: "brokerage-vol", className: "section-padding" },
        React.createElement(Row, { className: "relationship-head-block mx-0 px-0" },
            React.createElement("div", { className: "DMSanBold_18_700 txt_blackOne1 ps-0" }, "Brokerage & Volume")),
        React.createElement(Row, null,
            React.createElement(Col, { lg: 12, className: "generic-table salestableParentClass total-column-table brokragev-table" },
                React.createElement("table", { className: "salestableclass brokerage" },
                    React.createElement("thead", null,
                        React.createElement("tr", null,
                            React.createElement("th", { rowSpan: 2, className: "text-start vMid" },
                                React.createElement("div", null, "Segments")),
                            React.createElement("th", { colSpan: 2, className: "text-center below-border" },
                                React.createElement("div", null, "FTD")),
                            React.createElement("th", { colSpan: 2, className: "text-center below-border" },
                                React.createElement("div", null, "FTM")),
                            React.createElement("th", { colSpan: 2, className: "text-center below-border" },
                                React.createElement(GenericDropdown, { itemlist: FLMdrp, defaultVal: true, selectedDefaultVal: FLMdrpValue, selectedValue: setFLMdrp, externalClassname: "FLMdrp common-drp-new-midnight" }))),
                        React.createElement("tr", null,
                            React.createElement("th", null, "Brokerage"),
                            React.createElement("th", null, "Volume"),
                            " ",
                            React.createElement("th", null, "Brokerage"),
                            React.createElement("th", null, "Volume"),
                            " ",
                            React.createElement("th", null, "Brokerage"),
                            React.createElement("th", null, "Volume"))),
                    React.createElement("tbody", null, BrokerageVolumeRows.map(function (ele, idx) {
                        return (React.createElement("tr", { key: idx },
                            React.createElement("td", null, ele.Segments),
                            React.createElement("td", null,
                                React.createElement(React.Fragment, null,
                                    React.createElement(ReportValue, { val: ele === null || ele === void 0 ? void 0 : ele.FTDBrokerage, stream: false, onlyval: false, showZero: true }))),
                            React.createElement("td", null,
                                React.createElement(React.Fragment, null,
                                    React.createElement(ReportValue, { val: ele === null || ele === void 0 ? void 0 : ele.FTDVolume, stream: false, onlyval: false, showZero: true }))),
                            React.createElement("td", null,
                                React.createElement(React.Fragment, null,
                                    React.createElement(ReportValue, { val: ele === null || ele === void 0 ? void 0 : ele.FTMBrokerage, stream: false, onlyval: false, showZero: true }))),
                            React.createElement("td", null,
                                React.createElement(React.Fragment, null,
                                    React.createElement(ReportValue, { val: ele === null || ele === void 0 ? void 0 : ele.FTMVolume, stream: false, onlyval: false, showZero: true }))),
                            React.createElement("td", null,
                                React.createElement(React.Fragment, null,
                                    React.createElement(ReportValue, { val: ele === null || ele === void 0 ? void 0 : ele.FLMBrokerage, stream: false, onlyval: false, showZero: true }))),
                            React.createElement("td", null,
                                React.createElement(React.Fragment, null,
                                    React.createElement(ReportValue, { val: ele === null || ele === void 0 ? void 0 : ele.FLMVolume, stream: false, onlyval: false, showZero: true })))));
                    })))))));
};
export default BrokerageVolume;
